import { useMutation } from '@tanstack/react-query';
import { updateTasks } from 'shared/services/backend-api';
import { UpdateTask } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';

export const useUpdateTasksMutation = () =>
  useMutation({
    mutationFn: async (tasks: UpdateTask[]) => {
      const tasksToUpdate = tasks.map((task) => {
        const taskToUpdate = { ...task };

        if ('endStrategy' in task) {
          taskToUpdate.endStrategy = task.endStrategy
            ? {
                deadline:
                  task.endStrategy?.deadline && !task.schedules?.length
                    ? task.endStrategy.deadline
                    : null,
                completionCount: task.endStrategy.completionCount ?? null,
              }
            : null;
        }

        if ('reminderTime' in task) {
          taskToUpdate.reminderTime = task.reminderTime ?? null;
        }

        if ('hideOnTodo' in task) {
          taskToUpdate.hideOnTodo =
            task.type === TaskType.Habit ? task.hideOnTodo : null;
        }

        return taskToUpdate;
      });

      return updateTasks(tasksToUpdate);
    },
  });
